import { render, staticRenderFns } from "./Vocabulary.vue?vue&type=template&id=47540d5c"
import script from "./Vocabulary.vue?vue&type=script&lang=js"
export * from "./Vocabulary.vue?vue&type=script&lang=js"
import style0 from "./Vocabulary.vue?vue&type=style&index=0&id=47540d5c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports